import styled from "@emotion/styled";
import { Swiper, SwiperSlide } from "swiper/react";

import { fontRoboto, theme, ZIndexLayer } from "shared/lib/styles";

import { Popper } from "scmp-app/components/common/popper";

import IconSettings from "./icon-settings.svg";

export const StyledPopper = styled(Popper)``;

export const Container = styled.div`
  display: none;

  min-inline-size: 0;

  ${theme.breakpoints.up("tablet")} {
    display: flex;
    align-items: center;

    inline-size: 100%;
    max-inline-size: 704px;
    margin-block: 0;
    margin-inline: auto;
  }

  ${theme.breakpoints.up("desktop")} {
    max-inline-size: 1024px;
  }

  ${StyledPopper} {
    z-index: ${ZIndexLayer.Tooltip};
  }
`;

type FollowedItemProps = {
  $isSelected?: boolean;
};
export const FollowedItem = styled.div<FollowedItemProps>`
  padding-block: 10px;
  padding-inline: 16px;

  color: #bbbbbb;
  font-weight: 400;
  font-size: 14px;
  font-family: ${fontRoboto};
  line-height: 100%;
  white-space: nowrap;
  text-align: center;

  border: 1px solid #bbbbbb;
  border-radius: 3px;

  cursor: pointer;

  transition: all 0.2s ease-in-out;

  &:hover {
    color: #444444;

    border-color: #444444;
  }

  ${({ $isSelected }) =>
    $isSelected &&
    `
    background-color: #444444;
    color: #ffffff;
    border-color: #444444;

    &:hover {
      color: #ffffff;
    }
  `}
`;

export const StyledIconSettings = styled(IconSettings)`
  display: none;

  margin-inline-start: 6px;

  cursor: pointer;

  ${theme.breakpoints.up("tablet")} {
    display: block;
  }
`;

export const PopupContainer = styled.div`
  position: relative;
  z-index: 2000;

  inline-size: 375px;
  margin-block-start: 8px;
`;

export const StyledSwiper = styled(Swiper)`
  flex: 1;
  .swiper-button-prev {
    inset-inline-start: 0;

    margin-inline-start: -9px;

    &::before {
      background: linear-gradient(90deg, #ffffff 60%, hsla(0, 0%, 100%, 0));
    }
  }

  .swiper-button-next {
    inset-inline-end: 0;

    margin-inline-end: -9px;

    &::before {
      background: linear-gradient(270deg, #ffffff 60%, hsla(0, 0%, 100%, 0));
    }
  }

  .swiper-button-disabled {
    display: none;
  }

  .swiper-button-next,
  .swiper-button-prev {
    inset-block-start: 50%;

    inline-size: 22px;
    block-size: 36px;
    margin: 0;

    box-shadow: none;

    transform: translateY(-50%);

    &:before {
      position: absolute;
      inset-block-start: 0;
      content: "";
      z-index: -1;

      inline-size: 95px;
      block-size: 100%;
    }

    svg {
      inline-size: 12.7px;
      block-size: 22px;
      path {
        fill: #444444;
      }
    }
  }
`;
export const StyledSwiperSlide = styled(SwiperSlide)`
  &.swiper-slide {
    display: flex;
    align-items: center;

    inline-size: auto;
  }
`;
